(function() {
	/**
   * Render generic page
   * @param {object} props - The Routing context
   * @returns {object} Promise mit EJS Model
   */
	WebBaseAprovLV.renderGenericPage = function(props) {
		var params = {
			page: (props.context.params.page || ''),
			detail: (props.context.params.detail || '')
		};
		var opts = (props && props.options) || {};
		var kkDepth = (typeof opts.kkDepth === 'number') ? opts.kkDepth : 3;
		var baseTpl = (opts.template && String(opts.template).replace(/\?v=.*$/, '')) || 'templates/page.ejs.html';
		var queryString = WebBaseAprovLV.Utils.parseQuerystring(props.context.querystring);
		var now = new Date();
		var model = {
			element: null,
			template: baseTpl + '?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				navRaw: null, /* TODO: Probably obsolete. Fix or remove later. */
				pageRaw: null,
				nav: null,
				pageContent: null,
				collections: null
			}
		};
		return $.when(
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=' + kkDepth),
			ejs.preloadTemplate(model.template),
			ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template),
			ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template)
		)
		.then(function(pageXhr /*, tmplPage, tmplBreadcrumb, tmplSidebar */) {
			var pageRaw = Array.isArray(pageXhr) ? pageXhr[0] : (pageXhr || {});
			var pageItems = Array.isArray(pageRaw.items) ? pageRaw.items : [];
			model.data.pageRaw = pageRaw;
			model.data.pageContent = WebBaseAprovLV.Utils.getKKViewModel(pageRaw)[0] || {};
			if (!pageItems.length || !model.data.pageContent || !model.data.pageContent.system_id) {
				return $.Deferred().reject({
					code: 404,
					where: 'generic-page',
					page: params.page,
					detail: params.detail || ''
				}).promise();
			}
			if (params.detail) {
				return $.Deferred().reject({
					code: 404,
					where: 'generic-page-detail',
					page: params.page,
					detail: params.detail
				}).promise();
			}
			model.data.navRaw = {};
			var limit = WebBaseAprovLV.pagingWindow || 10;
			var container = model.data.pageContent.container || [];

			// News Container			
			var newsContainers = container.filter(function(component) {
				return component.system_type === 'news_container'
          && (component.container || []).length === 0
          && ((component.news_categories || []).length > 0
            || (component.news_tag || []).length > 0
            || (component.quelix_searchstring));
			});

			// Publication Container
			var publicationContainers = container.filter(function(component) {
				return component.system_type === 'publication_container'
          && (component.container || []).length === 0
          && (component.publication_categories || []).length > 0;
			});

			// Project Container
			var projectContainers = container.filter(function(component) {
				return component.system_type === 'project_container'
          && (component.container || []).length === 0
          && (component.project_categories || []).length > 0;
			});

			// Appointment Container
			var appointmentContainers = container.filter(function(component) {
				return component.system_type === 'appointment_container'
          && (component.container || []).length === 0
          && (component.appointment_categories || []).length > 0;
			});

			// FAQ Container
			var faqContainers = container.filter(function(component) {
				return component.system_type === 'faq_container'
          && (component.container || []).length === 0
          && ((component.faq_categories || []).length > 0
            || (component.faq_tag || []).length > 0);
			});

			// ServiceEditor Section
			var serviceEditorSection = container.filter(function(component) {
				return component.system_type === 'serviceeditor_section'
          && (component.container || []).length === 0
          && (component.service_ids || '').replace(/[^0-9,]/g, '').length > 0;
			});

			// Foreign Project Ids & Quelix Search
			var newsForeignProjectID = newsContainers.map(function(component) {
				var id = (component.foreign_project_id || '');
				return id.length ? id : undefined;
			});
			var projectForeignProjectID = projectContainers.map(function(component) {
				var id = (component.foreign_project_id || '');
				return id.length ? id : undefined;
			});
			var newsQuelixSearchstring = newsContainers.map(function(component) {
				var s = (component.quelix_searchstring || '');
				return s.length ? s : undefined;
			});

			// News
			var newsRequests = newsContainers.map(function(component) {
				var query = ['?system.type=news&includeTotalCount=true'];
				var skip = parseInt(queryString[component.system_codename + '_skip'] || 0, 10);

				var categories = (component.news_categories || []).map(function(category) { return category.codename; });
				var tags = (component.news_tag || []).map(function(tag) { return tag.codename; });

				if (categories.length) {
					query.push('elements.news_categories' +
            ((categories.length > 1) ? ('[any]=' + encodeURIComponent(categories.join(','))) : ('[contains]=' + encodeURIComponent(categories[0]))));
				}
				if (tags.length) {
					query.push('elements.news_tag' +
            ((tags.length > 1) ? ('[any]=' + encodeURIComponent(tags.join(','))) : ('[contains]=' + encodeURIComponent(tags[0]))));
				}

				query.push('order=elements.date[desc]');

				if (!isNaN(skip) && skip > 0) { query.push('skip=' + skip); }
				query.push('limit=' + limit);

				return query.join('&');
			});

			// Publications
			var publicationsRequests = publicationContainers.map(function(component) {
				var query = ['?system.type=publication_item&includeTotalCount=true'];
				var skip = parseInt(queryString[component.system_codename + '_skip'] || 0, 10);
				var categoryQuery = queryString[component.system_codename + '_category'] || '';

				var categories = (component.publication_categories || [])
				.map(function(category) { return category.codename; })
				.filter(function(category) {
					if (categoryQuery.length > 0) { return category === categoryQuery; }
					return true;
				});

				var order = (component.order__order || []).map(function(orderfield) { return orderfield.codename; });
				var tags = (component.news_tag || []).map(function(tag) { return tag.codename; });

				if (categories.length) {
					query.push('elements.publication_categories' +
            ((categories.length > 1) ? ('[any]=' + encodeURIComponent(categories.join(','))) : ('[contains]=' + encodeURIComponent(categories[0]))));
				}
				if (tags.length) {
					query.push('elements.news_tag' +
            ((tags.length > 1) ? ('[any]=' + encodeURIComponent(tags.join(','))) : ('[contains]=' + encodeURIComponent(tags[0]))));
				}

				if (order.length) {
					if (/date_time_desc/i.test(order)) {
						query.push('order=elements.date_time[desc]');
					} else if (/date_time_asc/i.test(order)) {
						query.push('order=elements.date_time[asc]');
					} else if (/title_desc/i.test(order)) {
						query.push('order=elements.title[desc]');
					} else {
						query.push('order=elements.title[asc]');
					}
				} else {
					query.push('order=elements.title[asc]');
				}

				if (!isNaN(skip) && skip > 0) { query.push('skip=' + skip); }
				query.push('limit=' + limit);

				return query.join('&');
			});

			// Projects
			var projectRequests = projectContainers.map(function(component) {
				var query = ['?system.type=project_item'];
				var categories = (component.project_categories || []).map(function(category) { return category.codename; });

				if (categories.length) {
					query.push('elements.project_categories' +
            ((categories.length > 1) ? ('[any]=' + encodeURIComponent(categories.join(','))) : ('[contains]=' + encodeURIComponent(categories[0]))));
				}
				query.push('order=elements.date_from[desc]');
				query.push('limit=3');
				return query.join('&');
			});

			// Appointments
			var appointmentRequests = appointmentContainers.map(function(component) {
				var query = ['?system.type=appointment_item&includeTotalCount=true'];
				var skip = parseInt(queryString[component.system_codename + '_skip'] || 0, 10);
				var categories = (component.appointment_categories || []).map(function(category) { return category.codename; });

				if (categories.length) {
					query.push('elements.appointment_categories' +
            ((categories.length > 1) ? ('[any]=' + encodeURIComponent(categories.join(','))) : ('[contains]=' + encodeURIComponent(categories[0]))));
				}

				query.push([
					'elements.date_from[gte]=',
					now.getFullYear(), '-',
					String('0' + (now.getMonth() + 1)).slice(-2), '-',
					String('0' + now.getDate()).slice(-2)
				].join(''));

				query.push('order=elements.date_from[asc]');

				if (!isNaN(skip) && skip > 0) { query.push('skip=' + skip); }
				query.push('limit=' + limit);

				return query.join('&');
			});

			// FAQs
			var faqRequests = faqContainers.map(function(component) {
				var query = ['?system.type=faq_item&includeTotalCount=true'];
				var categories = (component.faq_categories || []).map(function(category) { return category.codename; });
				var tags = (component.faq_tag || []).map(function(tag) { return tag.codename; });

				if (categories.length) {
					query.push('elements.faq_categories' +
            ((categories.length > 1) ? ('[any]=' + encodeURIComponent(categories.join(','))) : ('[contains]=' + encodeURIComponent(categories[0]))));
				}
				if (tags.length) {
					query.push('elements.faq_tag' +
            ((tags.length > 1) ? ('[any]=' + encodeURIComponent(tags.join(','))) : ('[contains]=' + encodeURIComponent(tags[0]))));
				}

				query.push('order=elements.question[asc]');
				query.push('limit=200');

				return query.join('&');
			});

			// ServiceEditor
			var serviceEditorRequests = serviceEditorSection.map(function(component) {
				var query = ['Services?lang=' + WebBaseAprovLV.lang];
				var service_ids = (component.service_ids || '').replace(/[^0-9,]/g, '');
				if (service_ids) { query.push('ids=' + service_ids); }
				return query.join('&');
			});
			var mapping = newsContainers
			.concat(publicationContainers, appointmentContainers, faqContainers, serviceEditorSection, projectContainers)
			.map(function(component) { return (component.system_codename || ''); });
			var req = newsRequests
			.concat(publicationsRequests, appointmentRequests, faqRequests, serviceEditorRequests, projectRequests)
			.map(function(kkUrl, index) {
				if (/system.type=news/i.test(kkUrl)) {
					if (typeof newsQuelixSearchstring[index] !== 'undefined') {
						return WebBaseAprovLV.Utils.getSearchData(newsQuelixSearchstring[index]);
					} else {
						return WebBaseAprovLV.Utils.getKKData(kkUrl, (newsForeignProjectID[index] || []));
					}
				} else if ((/Services/i.test(kkUrl)) && (/ids/i.test(kkUrl))) {
					return WebBaseAprovLV.Utils.getServiceEditorData(kkUrl);
				} else if (/system.type=project_item/i.test(kkUrl)) {
					return WebBaseAprovLV.Utils.getKKData(kkUrl, (projectForeignProjectID[index] || []));
				} else {
					return WebBaseAprovLV.Utils.getKKData(kkUrl);
				}
			});
			req.push(mapping);
			return $.when.apply($, req);
		})
		.then(function() {
			var args = Array.prototype.slice.call(arguments);
			var mapping = args.pop();
			var collections = {};
			args.forEach(function(item, i) {
				var codename = mapping.length >= i ? mapping[i] : '';
				var qs = [];
				if (codename.length && item && item.length) {
					for (var key in queryString) {
						switch (true) {
							case (new RegExp('^' + codename + '_(skip|limit)$', 'i')).test(key):
								break;
							default:
								qs.push([key.toLowerCase(), queryString[key]].join('='));
								break;
						}
					}
					collections[codename] = {
						queryString: qs.join('&'),
						raw: (item[0] || []),
						viewmodel: (item[0] && (item[0].items || []).length > 0)
							? (WebBaseAprovLV.Utils.getKKViewModel(item[0]) || [])
							: []
					};
				}
			});
			model.data.navRaw = {};
			model.element = $('#content');
			model.data = $.extend(model.data, {
				nav: WebBaseAprovLV.Utils.getKKViewModel(model.data.navRaw)[0] || {},
				collections: collections
			});
			WebBaseAprovLV.Utils.LastUpdateDateTime.calcAndShow(
				model.data.pageContent,
				model.data.collections,
				'defaultAndSpecial'
			);
			if (typeof opts.prepare === 'function') {
				try { opts.prepare(model, { queryString: queryString }); } catch(e) { console.warn('prepare() failed', e); }
			}
			var altRoutes = WebBaseAprovLV.Utils.getAlternateSouthTyrolWeatherRouting(params.page);
			if (altRoutes && (altRoutes.de || altRoutes.it || altRoutes.lld || altRoutes.en)) {
				model.data.UILangSwitchSpec = { segment: altRoutes };
			}
			return WebBaseAprovLV.Utils.transitionTo(model);
		})
		.then(function(ejsmodel) {
			if (ejsmodel && ejsmodel.data && ejsmodel.data.UILangSwitchSpec) {
				ejsmodel.data.UILangSwitch = WebBaseAprovLV.Utils.tuneUILangSwitchers({
					page: { segment: ejsmodel.data.UILangSwitchSpec.segment },
					detail: { id: '' }
				}, $('a.langchange'));
			}
			return ejsmodel;
		})
		.promise();
	};
})();
